<template>
    <div>
        <NuxtLayout>
            <NuxtPage/>
        </NuxtLayout>
    </div>
</template>

<script setup>
const { $sentryCaptureException } = useNuxtApp()

onMounted(() => {
    // $sentryCaptureException("Test exception")
})
</script>
